/**
 * BlogSLBlogPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait BlogSLBlogPage
 */

import { useBlogSLBlogPageLogic } from '@/hooks/traits/useBlogSLBlogPageLogic';
import type { BlogSLBlogPageConfig } from '@/hooks/traits/useBlogSLBlogPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { BlogSLBlogView as BlogSLBlogViewEntity } from '@app/shared';
import { BlogSLBlogHeaderView } from '@/components/traits/BlogSLBlogHeaderView';
import { BlogSLBlogPostsView } from '@/components/traits/BlogSLBlogPostsView';
import { BlogSLBlogHeroView } from '@/components/traits/BlogSLBlogHeroView';
import { Stack } from '@almadar/ui/components';
import { BlogSLBlogFooterView } from '@/components/traits/BlogSLBlogFooterView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface BlogSLBlogPageViewProps {
  config?: Partial<BlogSLBlogPageConfig>;
}

export function BlogSLBlogPageView({ config: propsConfig }: BlogSLBlogPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useBlogSLBlogPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['BlogSLBlogView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="BlogSL" trait="BlogSLBlogPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="BlogSLBlogPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><BlogSLBlogHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><BlogSLBlogHeroView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><BlogSLBlogPostsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><BlogSLBlogFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default BlogSLBlogPageView;
